/**
 * @file: countExactMatches.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

/**
 * Counts exact substring matches between text and pattern
 * @param text - Text to search in
 * @param pattern - Pattern to search for
 * @returns Number of exact matches found
 */
export function countExactMatches(text: string, pattern: string): number {
  let count = 0;

  // Check all possible substrings of the pattern
  for (let length = 1; length <= pattern.length; length++) {
    for (let start = 0; start <= pattern.length - length; start++) {
      const substring = pattern.slice(start, start + length);
      if (text.includes(substring)) {
        count++;
      }
    }
  }

  return count;
}
